import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { UserRoleClient, UserRoleView } from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class UserRoleService {
    constructor(private readonly client: UserRoleClient) {}

    async getAll(): Promise<UserRoleView[]> {
        return await lastValueFrom(this.client.userRoleGetAll());
    }
}
